import { render, staticRenderFns } from "./pay-online.vue?vue&type=template&id=52d3b6e0"
import script from "./pay-online.vue?vue&type=script&lang=js"
export * from "./pay-online.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports